import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
import { pushToDataLayer } from '../../util/ga-analytics/gaTracker';

var hash = require('hash-converter');

var Types = Actions.Types;
var INITIAL_STATE = {
  aadResponse: null,
  loadingAddress: false,
  addresses: [],
  addressBook: {},
  orders: [],
  isLoading: false,
  loggedin: false,
  validateAddress: true,
  reOrderSuccess: false,
  registerLogin: false,
  hasSavedCart: false,
  savedCartLocation: null
};

var accountReducer = function accountReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.LOGIN_SUCCESS:
      {
        var _payload$account, _payload$account$idTo, _payload$account2, _payload$account3, _payload$account3$idT;

        var payload = action.payload; //const userID = payload.account?.accountIdentifier;

        var userID = (_payload$account = payload.account) === null || _payload$account === void 0 ? void 0 : (_payload$account$idTo = _payload$account.idTokenClaims) === null || _payload$account$idTo === void 0 ? void 0 : _payload$account$idTo.sub; //gtag('set', {'user_id': userID}); // Set the user ID using signed-in user_id.

        var User_Id = {
          event: 'set',
          user_Id: {
            userID: userID
          }
        };
        pushToDataLayer(User_Id);
        return _objectSpread(_objectSpread({}, state), {}, {
          loggedin: true,
          aadResponse: payload,
          cookie: {
            userID: payload === null || payload === void 0 ? void 0 : (_payload$account2 = payload.account) === null || _payload$account2 === void 0 ? void 0 : _payload$account2.accountIdentifier,
            signIn: hash.SHA256(payload === null || payload === void 0 ? void 0 : (_payload$account3 = payload.account) === null || _payload$account3 === void 0 ? void 0 : (_payload$account3$idT = _payload$account3.idToken) === null || _payload$account3$idT === void 0 ? void 0 : _payload$account3$idT.signInName)
          }
        });
      }

    case Types.STORE_LOGIN_SUCCESS:
      {
        var aadResponse = action.aadResponse;
        return _objectSpread(_objectSpread({}, state), {}, {
          storeLoggedin: aadResponse === null || aadResponse === void 0 ? void 0 : aadResponse.isLoggedIn,
          idToken: aadResponse === null || aadResponse === void 0 ? void 0 : aadResponse.token
        });
      }

    case Types.LOGOUT_SUCCESS:
      {
        console.log('This would be logged out success');
        document.cookie = 'scLoggedin=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        return _objectSpread(_objectSpread({}, state), {}, {
          loggedin: false,
          aadResponse: null,
          registerLogin: false,
          cookie: {}
        });
      }

    case Types.FETCH_ADDRESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loadingAddress: true
        });
      }

    case Types.GET_ADDRESS:
      {
        var addresses = action.addresses;
        return _objectSpread(_objectSpread({}, state), {}, {
          loadingAddress: false,
          isLoading: false,
          addresses: addresses,
          addressBook: {}
        });
      }

    case Types.RECEIVE_ADDRESS:
      {
        var address = action.address,
            addressType = action.addressType;
        var addressBook = state.addressBook || {};

        if (!addressBook[addressType]) {
          addressBook[addressType] = [];
        }

        if (!addressBook[addressType].includes(address)) {
          addressBook[addressType].push(address);
        }

        return _objectSpread(_objectSpread({}, state), {}, {
          addressBook: addressBook,
          isLoading: false
        });
      }

    case Types.POST_ADDRESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.DELETE_ADDRESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });
      }

    case Types.REQUEST_GET_ORDERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case Types.GET_ORDERS:
      {
        var orders = action.orders;
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false,
          orders: orders
        });
      }

    case Types.REQUEST_GUEST_ORDER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          guestOrderLoad: true
        });
      }

    case Types.RESPONSE_GUEST_ORDER:
      {
        var _orders = action.orders;
        return _objectSpread(_objectSpread({}, state), {}, {
          orders: _orders,
          guestOrderLoad: false
        });
      }

    case Types.ERROR_GUEST_ORDER:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          guestOrderLoad: false
        });
      }

    case Types.TO_RETURN:
      {
        var toReturn = action.toReturn;
        return _objectSpread(_objectSpread({}, state), {}, {
          toReturn: toReturn,
          successReturn: false
        });
      }

    case Types.SET_SHOW_REPLACEMENT:
      {
        var showReplacement = action.showReplacement;
        return _objectSpread(_objectSpread({}, state), {}, {
          showReplacement: showReplacement
        });
      }

    case Types.RETURN_ORDER:
      {
        return _objectSpread({}, state);
      }

    case Types.RESPONSE_RETURN_ORDER:
      {
        var _orders2 = action.orders;
        return _objectSpread(_objectSpread({}, state), {}, {
          successReturn: true,
          orders: _orders2
        });
      }

    case Types.RESPONSE_RETURN_ORDER_ERR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          returnError: true
        });
      }

    case Types.RESPONSE_RE_ORDER:
      {
        var reOrderSuccess = action.reOrderSuccess;
        return _objectSpread(_objectSpread({}, state), {}, {
          reOrderSuccess: reOrderSuccess
        });
      }

    case Types.RECEIVE_ACCOUNT_DETAILS:
      {
        var registerLogin = action.registerLogin;
        return _objectSpread(_objectSpread({}, state), {}, {
          registerLogin: registerLogin
        });
      }

    case Types.SET_HAS_SAVED_CART:
      {
        var hasSavedCart = action.hasSavedCart,
            savedCartLocation = action.savedCartLocation;
        return _objectSpread(_objectSpread({}, state), {}, {
          hasSavedCart: hasSavedCart,
          savedCartLocation: savedCartLocation
        });
      }

    default:
      {
        return state;
      }
  }
};

export default accountReducer;